export default __webpack_public_path__ + "static/media/gridMobile1.1f905fd6.png";